import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORKS]: {
		url: '/company/:companyId/order_generators/field_works/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK]: {
		url: '/company/:companyId/order_generators/field_works/:fieldWorkId/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK_PREVIEW]: {
		url: '/company/:companyId/order_generators/field_works/:fieldWorkId/preview/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK_POPUP]: {
		url: '/company/:companyId/order_generators/field_works/:fieldWorkId/popup/',
	},


	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].CREATE_ORDER_GENERATORS_FIELDS_WORK]: {
		url: '/company/:companyId/order_generators/field_works/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].PUT_ORDER_GENERATORS_FIELDS_WORK]: {
		url: '/company/:companyId/order_generators/field_works/:fieldWorkId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].PATCH_ORDER_GENERATORS_FIELDS_WORK]: {
		url: '/company/:companyId/order_generators/field_works/:fieldWorkId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].DELETE_ORDER_GENERATORS_FIELDS_WORK]: {
		url: '/company/:companyId/order_generators/field_works/:fieldWorkId/',
		requestOptions: {
			method: 'DELETE',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].GET_ORDER_GENERATORS_FIELDS_WORK_RELATED_PLAN_WORKS]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/related_plan_works/',
	},

}